import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import env from "./env";

export default class AuthService {
  constructor($http, $localStorage, $state, $stateParams, SecurityService, $q, EnvService, $rootScope, $timeout, $location, $cookies) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$env = EnvService;
    this.$q = $q;
    this.$location = $location;
    this.$cookies = $cookies;
    this.recover_email = "";
    this.billingUrl = "jbl/v1/validate?format=json&fields=billingTutorialTracking";
    this.validatePayInfo =
      "jbl/v1/validate?format=json&fields=company.undeletedPaymentInfos.id,authorities,acceptedBackgroundCheck,homeContactInfo.isMobilePhoneVerified,company.autoAcceptLimitTimeMark,billingTutorialTracking,company.autoAccept,company.autoManage,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.billingContactInfo.email,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.payByInvoice,company.sendInvoice,company.defaultPlan.requiresSubscription,company.enableSubscription";
    this.fullValidateUrlWeb =
      "jbl/v1/validate?format=json&fields=username,dateBirth,ssn,authorities,acceptedBackgroundCheck,homeContactInfo.isMobilePhoneVerified,video1,brands,company.autoAcceptLimitTimeMark,billingTutorialTracking,id,smsChatNotificationOn,profilePictureUri,company.billingContactInfo.email,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.invoiceMarkup,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.autoAccept,company.autoManage,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.defaultPlan.requiresSubscription,homeContactInfo.isMobilePhoneVerified,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoOtherUriFree,company.companyLogoUriFree,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
    this.fullValidateUrl = "jbl/v1/validate?format=json&conf=web";
    this.signInUrlLazy =
      "jbl/v1/login?format=json&fields=username,dateBirth,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,ssn,bio,company.autoAcceptLimitTimeMark,billingTutorialTracking,notifPref.jobbleTypes,video1,brands,id,smsChatNotificationOn,profilePictureUri,company.billingContactInfo.email,company.autoAccept,company.autoManage,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.invoiceMarkup,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,company.defaultPlan.requiresSubscription,homeContactInfo.phoneMobile,homeContactInfo.isMobilePhoneVerified,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
    this.validateUrl =
      "jbl/v1/validate?format=json&fields=username,dateBirth,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,company.autoAcceptLimitTimeMark,billingTutorialTracking,video1,isVerified,ssn,brands,id,smsChatNotificationOn,company.billingContactInfo.email,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.autoAccept,company.autoManage,company.invoiceMarkup,profilePictureUri,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.defaultPlan.requiresSubscription,homeContactInfo.isMobilePhoneVerified,company.companyLogoOtherUriFree,company.companyLogoUriFree,company.companyLogoUri,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.industryType.name,company.industryType.id,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partner,company.rds_company,numberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
    this.signInUrl =
      "jbl/v1/login?format=json&fields=username,dateBirth,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,company.autoAcceptLimitTimeMark,ssn,billingTutorialTracking,video1,brands,id,smsChatNotificationOn,profilePictureUri,company.billingContactInfo.email,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.invoiceMarkup,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.autoAccept,company.autoManage,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,homeContactInfo.isMobilePhoneVerified,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoOtherUriFree,company.companyLogoUriFree,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
    this.getCompanyPlanUrl =
      "jbl/v1/validate?format=json&fields=username,dateBirth,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,company.autoAcceptLimitTimeMark,billingTutorialTracking,company.billingContactInfo.email,company.sendInvoice,company.enableSubscription,company.payByInvoice,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.autoAccept,company.autoManage,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct";
    this.validate_from_marketing_site_url =
      "jbl/v1/validate?format=json&fields=username,isVerified,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,company.autoAcceptLimitTimeMark,billingTutorialTracking,company.isVerified,id,email,company.id,company.payByInvoice,company.sendInvoice,company.defaultPlan.requiresSubscription,company.billingContactInfo.email,company.enableSubscription,company.invoiceMarkup,company.defaultPlan.id,company.autoAccept,company.autoManage,company.undeletedPaymentInfos,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.name,company.legalCompanyName,company.ein,company.numberOfLocations";
    this.loginUrlWithValidate =
      "jbl/v1/validate?format=json&fields=username,email,id,company.id,company.isVerified,authorities,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.defaultPlan.companyFeePct,company.billingContactInfo.email,company.defaultPlan.requiresSubscription,company.undeletedPaymentInfos.bankName,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.isMobileVerified,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.ein,company.mainContactInfo.state,company.mainContactInfo.zipCode,company.description,company.autoAccept,company.autoManage,company.enableSubscription,company.payByInvoice,company.sendInvoice,company.name,company.legalCompanyName,bgCheckStatus,company.undeletedPaymentInfos.stripeId,acceptedBackgroundCheck";
    this.companyVerificationUrl =
      "jbl/v1/validate?format=json&fields=username,email,id,company.id,company.isVerified,authorities,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.defaultPlan.companyFeePct,company.billingContactInfo.email,company.defaultPlan.requiresSubscription,company.undeletedPaymentInfos.bankName,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.isMobileVerified,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.ein,company.mainContactInfo.state,company.mainContactInfo.zipCode,company.description,company.autoAccept,company.autoManage,company.enableSubscription,company.payByInvoice,company.sendInvoice,company.name,company.legalCompanyName,bgCheckStatus,company.undeletedPaymentInfos.stripeId,company.companyLogoUriFree,company.companyLogoUri";
    this.$rootScope = $rootScope;
    this.event_types = [];

    this.USER_UPDATE_TRIGGER = "RecentUserUpdated";
    this.USER_UPDATE_TRIGGER_TRIMMED = "RecentUserUpdatedTrimmed";

    if (this.isLoggedIn()) {
      if (this.$localStorage.logged_user && this.$localStorage.logged_user.company && this.$localStorage.logged_user.company.id) {
        this.validateUserByTokenWeb(this.getAccessToken())
          .then((response) => {
            //console.log("Validate Response");
            //console.dir(response);
            this.setMostRecentUser(response.data);
            this.emitMostRecentUser();
          })
          .catch((error) => {
            this.logout();
            //console.log("VALDIATE ERRRORRR");
            //console.dir(error);
          });
      } else {
        this.validateUserByToken(this.getAccessToken())
          .then((response) => {
            //console.log("Validate Response");
            //console.dir(response);
            this.setMostRecentUser(response.data);
            this.emitMostRecentUser();
          })
          .catch((error) => {
            this.logout();
            //console.log("VALDIATE ERRRORRR");
            //console.dir(error);
          });
      }
    }
  }

  emitMostRecentUser() {
    this.$timeout(() => {
      this.$rootScope.$emit(this.USER_UPDATE_TRIGGER, this.getUserData());
      this.$rootScope.$emit(this.USER_UPDATE_TRIGGER_TRIMMED, this.getUserData());
    });
  }

  logout() {
    this.signOut()
      .then((response) => {
        this.clearLoggedFields();
        this.$location.path("/jobs");
        window.location.reload();
      })
      .catch((err) => {
        this.clearLoggedFields();
        this.$location.path("/jobs");
        window.location.reload();
      });
  }

  logoutOnboarding() {
    this.signOut()
      .then((response) => {
        this.clearLoggedFields();
        //this.$location.path("/signin");
        window.location.reload();
      })
      .catch((err) => {
        this.clearLoggedFields();
        //this.$location.path("/signin");
        window.location.reload();
      });
  }

  clearLoggedFields() {
    this.$localStorage.logged_user = null;
    this.$rootScope.channels = null;
    this.$rootScope.companyLogoUri = null;
    this.$rootScope.inboxLink = null;
    this.$rootScope.channelsHaveLoaded = null;
    this.$rootScope.teams = null;
    this.$rootScope.teamsSimple = null;
    this.$rootScope.globalParams = null;
    this.$rootScope.imgFromProfilePage = null;
    this.$rootScope.jobbleTypes = null;
    this.$rootScope.jobs = null;
    this.$rootScope.jobsSeenOnce = null;
    this.$rootScope.boardParameters = null;
  }

  isLoggedIn() {
    let loggedIn = true;

    const logged_user = this.$localStorage.logged_user;

    if (this.$security.isUndefinedOrNull(logged_user)) {
      console.warn("There is no logged in user in local storage.");
      loggedIn = false;
      return loggedIn;
    }

    if (this.$security.isUndefinedOrNull(logged_user.username)) {
      console.warn("The logged in user in local storage is missing an username.");
      loggedIn = false;
    }

    if (this.$security.isUndefinedOrNull(logged_user.email)) {
      console.warn("The logged in user in local storage is missing an email.");
      loggedIn = false;
    }

    if (this.$security.isUndefinedOrNull(logged_user.access_token)) {
      console.warn("The logged in user in local storage is missing an access token.");
      loggedIn = false;
    }
    return loggedIn;
  }

  signOut() {
    var _this = this;

    //_this.$localStorage.removeItem('logged_user');
    localStorage.removeItem("logged_user");

    return this.$http.post(_this.$env.getAPIEndPoint() + "jbl/v1/logout", {}, {headers: {Authorization: "Bearer " + _this.getAccessToken()}});
  }

  signIn() {}

  signUp() {}

  reloadCurrentMobileUser() {
    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=isVerified",
      headers: {
        Authorization: "Bearer " + this.getAccessToken(),
      },
      data: {},
    };

    return this.$http(req);
  }

  getCompanyPlan() {
    var _this = this;

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + _this.getCompanyPlanUrl,
      headers: {Authorization: "Bearer " + _this.getAccessToken()},
      data: {},
    };

    return _this.$http(req);
  }

  grab_company_logo(token) {
    var _this = this;

    var req = {
      method: "GET",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/validate?format=json&fields=company.companyLogoUriFree,company.companyLogoUri,company.fileCOMPANY_LOGO1IMG_75x75",
      headers: {
        Authorization: "Bearer " + _this.getAccessToken(),
      },
      data: {},
    };
    return _this.$http(req);
  }

  setMostRecentUser(user) {
    this.$localStorage.logged_user = user;
  }

  setRecentCompanyData(company) {
    if (this.$localStorage.logged_user && this.$localStorage.logged_user.company && company) {
      this.$localStorage.logged_user.company.description = company.description;
      this.$localStorage.logged_user.company.name = company.name;
      this.$localStorage.logged_user.company.ein = company.ein;
      this.$localStorage.logged_user.company.legalCompanyName = company.legalCompanyName;
      this.$localStorage.logged_user.company.numberOfLocations = company.numberOfLocations;
      this.$localStorage.logged_user.company.mainContactInfo.city = company.mainContactInfo.city;
      this.$localStorage.logged_user.company.mainContactInfo.phoneMobile = company.mainContactInfo.phoneMobile;
      this.$localStorage.logged_user.company.mainContactInfo.state = company.mainContactInfo.state;
      this.$localStorage.logged_user.company.mainContactInfo.streetLine1 = company.mainContactInfo.streetLine1;
      this.$localStorage.logged_user.company.mainContactInfo.zipCode = company.mainContactInfo.zipCode;
    }
  }

  refreshCurrentUserBilling() {
    console.log("refreshCurrentUserBilling");
    console.dir(this.billingUrl);
    return new Promise((resolve, reject) => {
      let req = {
        method: "GET",
        url: this.$env.getAPIEndPoint() + this.billingUrl,
        headers: {Authorization: "Bearer " + this.getAccessToken()},
        data: {},
      };

      this.$http(req).then((response) => {
        if (response.status === 200) {
          //this.setMostRecentUser(response.data);
          //this.emitMostRecentUser();
          console.log("new user", response);
          resolve(this.getUserData());
        } else {
          console.log("error reloading the current user");
          reject();
        }
      });
    });
  }

  refreshCurrentUserDashboard() {
    return new Promise((resolve, reject) => {
      let req = {
        method: "GET",
        url:
          this.$env.getAPIEndPoint() +
          "jbl/v1/validate?format=json&fields=company.totalNumberOfPublishedEvents,company.totalNumberOfDraftEvents,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfNonCloseEvents",
        headers: {Authorization: "Bearer " + this.getAccessToken()},
        data: {},
      };

      this.$http(req).then((response) => {
        if (response.status === 200) {
          //this.setMostRecentUser(response.data);
          //this.emitMostRecentUser();
          console.log("new user event data", response);
          resolve(response.data);
        } else {
          console.log("error reloading the current user");
          reject();
        }
      });
    });
  }

  refreshCurrentUser() {
    return new Promise((resolve, reject) => {
      let req = {
        method: "GET",
        url: this.$env.getAPIEndPoint() + this.fullValidateUrlWeb,
        headers: {Authorization: "Bearer " + this.getAccessToken()},
        data: {},
      };

      this.$http(req).then((response) => {
        if (response.status === 200) {
          this.setMostRecentUser(response.data);
          this.emitMostRecentUser();
          console.log("new user", response);
          resolve(this.getUserData());
        } else {
          console.log("error reloading the current user");
          reject();
        }
      });
    });
  }

  reloadCurrentUser() {
    let req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + this.fullValidateUrlWeb,
      headers: {Authorization: "Bearer " + this.getAccessToken()},
      data: {},
    };

    this.$http(req).then((response) => {
      if (response.status === 200) {
        this.setMostRecentUser(response.data);
        return response.data;
        //return this.$localStorage.logged_user;
      } else {
        console.log("error reloading the current user");
      }
    });
  }

  validateUserByTokenWeb(token) {
    token = token.trim();
    let req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + this.fullValidateUrlWeb,
      headers: {Authorization: "Bearer " + token},
      data: {},
    };
    return this.$http(req);
  }

  validateCompanyByTokenWeb(token) {
    token = token.trim();
    let req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + this.companyVerificationUrl,
      headers: {Authorization: "Bearer " + token},
      data: {},
    };
    return this.$http(req);
  }

  validateUserByToken(token) {
    token = token.trim();

    console.log("whenzzzz");

    let req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + this.fullValidateUrl,
      headers: {Authorization: "Bearer " + token},
      data: {},
    };
    return this.$http(req);
  }

  validate_from_marketing_site(token) {
    var _this = this;
    let req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + _this.validate_from_marketing_site_url,
      headers: {Authorization: "Bearer " + token},
      data: {},
    };
    return _this.$http(req);
  }

  reloadNewPostingType() {
    var _this = this;

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=company.payPerConnect",
      headers: {
        Authorization: "Bearer " + _this.getAccessToken(),
      },
      data: {},
    };

    return _this.$http(req);
  }

  submitRecoverLink(email) {
    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "forgot_password.json",
      data: {},
    };
    return this.$http(req);
  }

  getRecoverEmail() {
    return this.recover_email;
  }

  setRecoverEmail(recover_email) {
    this.recover_email = recover_email;
  }

  getEventTypes() {
    var url = this.$env.getAPIEndPoint() + "jbl/v1/event-types?conf=web&format=json&max=100&q=%7B%7D";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.getAccessToken(),
      },
      data: {},
    };

    return this.$http(req);
  }

  getJobbleTypes(max) {
    if (!max) {
      var max = 100;
    }
    var url = this.$env.getAPIEndPoint() + "public/jobble-types?format=json&max=" + max + "&displayOrder=asc&fields=id,name,displayOrder";
    var req = {method: "GET", url: url, headers: {}, data: {}};
    return this.$http(req);
  }

  getAccessToken() {
    if (this.$localStorage.logged_user) {
      return this.$localStorage.logged_user.access_token;
    }
  }

  getUserData() {
    return this.$localStorage.logged_user;
  }

  getAllJobbles(maxCount, offset = 0) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/jobbles?format=json&conf=web&isPublished=true&isPayed=false&isReserved=false&excludeChainAndPoolDupe=true&sort=dateCreated&order=desc&excludeStartTimePassed=false&max=" +
      maxCount.toString() +
      "&offset=" +
      offset.toString();
    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.getAccessToken()},
      data: {},
    };
    return this.$http(req);
  }

  getTransactions(startDate, endDate, intervalType = "1d") {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/stats/payment?statType=sum-amountCompany&format=json&isDeleted=false&startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&interval=" +
      intervalType;
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  getEvents(startDate, endDate, intervalType = "1d", isClosed = false) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/stats/event?format=json&isDeleted=false&startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&interval=" +
      intervalType;
    if (isClosed) {
      url += "&isClosed=true";
    }

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  getApplicants(startDate, endDate, intervalType = "1d") {
    // var url = 'https://dev.int.jobbleapp.com/jobbleapi/jbl/v1/stats/application?isDeleted=false&format=json&startDate=2016-05-23T00:00:00-04:00&endDate=2016-05-29T23:59:59-04:00&interval=1d';

    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/stats/application?format=json&isDeleted=false&startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&interval=" +
      intervalType;
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  getOpenings(startDate, endDate, intervalType = "1d") {
    // var url = 'https://dev.int.jobbleapp.com/jobbleapi/jbl/v1/stats/jobble?isDeleted=false&format=json&startDate=2016-05-23T00:00:00-04:00&endDate=2016-05-29T23:59:59-04:00&interval=1d';
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/stats/jobble?format=json&isDeleted=false&startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&interval=" +
      intervalType;

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  getHires(startDate, endDate, intervalType = "1d") {
    // var url = 'https://dev.int.jobbleapp.com/jobbleapi/jbl/v1/stats/application?applicationStatus=1&format=json&startDate=2016-05-23T00:00:00-04:00&endDate=2016-05-29T23:59:59-04:00&interval=1d&isDeleted=false';
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/stats/application?applicationStatus=1&format=json&isDeleted=false&startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&interval=" +
      intervalType;

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  getPlans() {
    var url = this.$env.getAPIEndPoint() + "jbl/v1/plans?format=json&conf=web&max=100";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }

  lazyLoginExists(user) {
    var _this = this;
    //fields=username,dateBirth,ssn,video1,brands,id,smsChatNotificationOn,profilePictureUri,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications
    //fields=username,id,smsChatNotificationOn,emailChatNotificationOn,firstName,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.jobblerFeePct,company.defaultPlan.name,company.defaultPlan.companyFeePct,company.companyLogoUri,company.paymentInfos.cardBrand,company.paymentInfos.validated,company.paymentInfos.cardExpirationMonth,company.paymentInfos.cardExpirationYear,company.paymentInfos.cardToken,company.paymentInfos.last4,company.paymentInfos.bankName,company.paymentInfos.stripeId,company.paymentInfos.nickname,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.partner
    var req = {
      method: "POST",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/login?format=json&fields=username,dateBirth,ssn,video1,brands,id,smsChatNotificationOn,profilePictureUri,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,company.sendInvoice,company.enableSubscription,company.payByInvoice,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications",
      data: {
        username: user.emailLogin,
        password: user.passwordLogin,
      },
    };

    return this.$http(req);
  }

  getUserByEmail(email) {
    var _this = this;

    var req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/users/get?format=json&verbosity=5",
      headers: {authorization: "Bearer " + this.getAccessToken()},
      data: {email: email},
    };

    return this.$http(req);
  }

  lazySignin(user) {
    var _this = this;

    var req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + _this.signInUrl,
      data: {
        username: user.email,
        password: user.password,
      },
    };

    return this.$http(req);
  }

  lazyReg(user, marketingParamsSubgStr) {
    var _this = this;

    var urlReq = null;

    if (marketingParamsSubgStr) {
      urlReq = _this.$env.getAPIEndPoint() + "register/register?format=json&conf=web" + marketingParamsSubgStr;
    } else {
      urlReq = _this.$env.getAPIEndPoint() + "register/register?format=json&conf=web";
    }

    let req = {};

    if (user.Company) {
      req = {
        method: "POST",
        url: urlReq,
        data: {
          company: {
            defaultPlan: 1,
            mainContactInfo: {
              phoneMobile: user.phoneMobile,
            },
            name: user.companyName,
          },
          firstName: user.firstName,
          lastName: user.lastName,
          username: user.email,
          password: user.password,
          termsOfService: true,
          acceptedWebAgreement: true,
          homeContactInfo: {
            phoneMobile: user.phoneMobile,
          },
        },
      };
    } else {
    }
    return this.$http(req);
  }

  getRatings(offset, id) {
    var req = {
      method: "GET",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        id +
        "/ratings/received?format=json&conf=web&sort=dateCreated&order=desc&max=5&offset=" +
        offset,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return this.$http(req);
  }

  getChatUploadUrl(id, fileType) {
    var url = "";
    try {
      if (id) {
        url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + id + "/files?format=json&fileType=" + fileType + "&replace=true";
      } else {
        url =
          this.$env.getAPIEndPoint() +
          "jbl/v1/companies/" +
          this.$localStorage.logged_user.companyId +
          "/files?format=json&fileType=" +
          fileType +
          "&replace=true";
      }
    } finally {
      return url;
    }
  }

  getUploadUrl(id, file) {
    var url = "";
    try {
      if (id) {
        if (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg") {
          url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + id + "/files?format=json&fileType=9&replace=true";
        } else {
          url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + id + "/files?format=json&fileType=7&replace=true";
        }
      } else {
        if (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg") {
          url =
            this.$env.getAPIEndPoint() +
            "jbl/v1/companies/" +
            this.$localStorage.logged_user.companyId +
            "/files?format=json&fileType=9&replace=true";
        } else {
          url =
            this.$env.getAPIEndPoint() +
            "jbl/v1/companies/" +
            this.$localStorage.logged_user.companyId +
            "/files?format=json&fileType=7&replace=true";
        }
      }
    } finally {
      return url;
    }
  }

  getMapsKey() {
    var _this = this;
    console.log("what is the env");
    console.dir(_this.$env);
  }

  populateCardImage(info) {
    if (info.cardBrand === "American Express") {
      info.image = "fa fa-cc-amex";
    }
    if (info.cardBrand === "Visa") {
      info.image = "fa fa-cc-visa";
    }
    if (info.cardBrand === "Discover") {
      info.image = "fa fa-cc-discover";
    }
    if (info.cardBrand === "MasterCard") {
      info.image = "fa fa-cc-mastercard";
    }

    if (info.bankName) {
      info.image = "fas fa-university";
    }

    return info.image;
  }

  formatPaymentMethods(paymentMethods) {
    var _this = this;

    var methods = [];

    console.log("formatPaymentMethods");
    console.dir(paymentMethods);

    try {
      paymentMethods.forEach(function (paymentMethod) {
        paymentMethod.isChecked = false;

        if (paymentMethod.bankName) {
          if (paymentMethod.validated) {
            paymentMethod.displayName = paymentMethod.bankName;
            paymentMethod.displayExpires = "--";
            paymentMethod.displayLast4 = paymentMethod.last4;
            paymentMethod.displayNickName = "--";
            paymentMethod.payType = "bank";
            paymentMethod.stripeId = paymentMethod.stripeId;
            paymentMethod.image = _this.populateCardImage(paymentMethod);
            methods.push(paymentMethod);
          }
        } else {
          paymentMethod.displayName = paymentMethod.cardBrand;
          paymentMethod.displayLast4 = paymentMethod.last4;
          paymentMethod.displayExpires = paymentMethod.cardExpirationDate;
          paymentMethod.stripeId = paymentMethod.stripeId;
          paymentMethod.displayNickName = paymentMethod.nickname ? paymentMethod.nickname : "--";
          paymentMethod.payType = "card";
          paymentMethod.image = _this.populateCardImage(paymentMethod);
          methods.push(paymentMethod);
        }
      });
    } finally {
      console.log("methods");
      console.dir(methods);
      return methods;
    }
  }

  selectPaymentMethod(paymenMethods, paymentMethod) {
    var _this = this;

    try {
      var paymentMethodFiltered = paymenMethods.filter(function (p) {
        return p.isChecked === true;
      });
    } finally {
      if (paymentMethodFiltered && paymentMethodFiltered.length > 0) {
        paymentMethodFiltered[0].isChecked = false;
      }

      paymentMethod.isChecked = true;

      return paymenMethods;
    }
  }

  deleteCard(id) {
    var req = {
      method: "DELETE",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/companies/" +
        this.$localStorage.logged_user.company.id +
        "/payment-infos/" +
        id +
        "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
    };

    return this.$http(req);
  }

  getHubspotToken() {
    const cookies = this.$cookies.getAll() || {};

    return cookies.hubspotutk || null;
  }

  registerJobblerInHubspot(user) {
    var xhr = new XMLHttpRequest();
    var url = "https://api.hsforms.com/submissions/v3/integration/submit/421423/7a14e805-a099-47a1-b2c1-c65615ad7041";

    var data = {
      submittedAt: Date.now(),
      fields: [
        {
          name: "email",
          value: user.email,
        },
      ],
      context: {
        hutk: this.getHubspotToken(),
        pageUri: window.location.href,
        pageName: "",
      },
    };

    var final_data = JSON.stringify(data);

    xhr.open("POST", url);

    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        console.log(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == 400) {
        console.log(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == 403) {
        console.log(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == 404) {
        console.log(xhr.responseText);
      }
    };

    xhr.send(final_data);
  }

  registerCompanyInHubspot(user) {
    var xhr = new XMLHttpRequest();
    var url = "https://api.hsforms.com/submissions/v3/integration/submit/421423/8235df8f-a6e5-4150-81fd-10176648e0ce";

    var data = {
      submittedAt: Date.now(),
      fields: [
        {
          name: "email",
          value: user.email,
        },
      ],
      context: {
        hutk: this.getHubspotToken(),
        pageUri: window.location.href,
        pageName: "",
      },
    };

    var final_data = JSON.stringify(data);

    xhr.open("POST", url);

    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        console.log(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == 400) {
        console.log(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == 403) {
        console.log(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == 404) {
        console.log(xhr.responseText);
      }
    };

    xhr.send(final_data);
  }

  registerMobileUser(user, ref) {
    try {
      this.registerJobblerInHubspot(user);
    } catch (e) {
      console.error("Hubspot registration error:", e);
    }

    ref = ref || window.location.origin + "/jobs";

    const data = {
      username: user.email,
      password: user.password,
      acceptedWebAgreement: true,
      acceptedPrivacyPolicy: true,
      acceptedCookiePolicy: true,
    };

    if (user.first_name) data.firstName = user.first_name;

    if (user.last_name) data.lastName = user.last_name;

    if (user.zip_code) data.homeContactInfo = {zipCode: user.zip_code};

    if (user.isBenjaminUser) {
      data.isBenjaminUser = true;
    }

    if (user.notifPref) {
      data.notifPref = user.notifPref;
    }

    let url = this.$env.getAPIEndPoint() + "register/register?format=json&conf=web&ref=" + ref;

    const searchParams = this.$location.$$search || {};

    if (searchParams.utm_source) url += `&jsrc=${searchParams.utm_source}`;

    if (searchParams.utm_campaign) url += `&jcam=${searchParams.utm_campaign}`;

    let req = {
      method: "POST",
      url,
      data,
    };

    return this.$http(req);
  }

  lazyLoginMobileUser(user) {
    var _this = this;
    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + _this.signInUrlLazy,
      data: {username: user.email, password: user.password},
    };

    return this.$http(req);
  }

  isAdmin() {
    var _this = this;

    let isAdmin = null;

    if (
      _this.$localStorage.logged_user.username.indexOf("jobble.com") !== -1 ||
      _this.$localStorage.logged_user.username.indexOf("jobbleapp.com") !== -1
    ) {
      isAdmin = true;
    }

    return isAdmin;
  }

  hasCompletedPaymentInformation() {
    const user = this.getUserData();

    let complete = {
      completed: false,
      address_complete: false,
      payment_added: false,
      // ein_complete: false
    };

    if (!user) {
      return complete;
    }

    if (user.company && user.company.mainContactInfo) {
      complete.address_complete =
        user.company.mainContactInfo.streetLine1 &&
        user.company.mainContactInfo.city &&
        user.company.mainContactInfo.state &&
        user.company.mainContactInfo.zipCode;
    }

    // if (user.company) {
    //     complete.ein_complete = !!(user.company.ein);
    // }

    if (user.company && user.company.undeletedPaymentInfos) {
      complete.payment_added = user.company.undeletedPaymentInfos.length >= 1;
    }

    complete.completed = complete.payment_added; //&& complete.ein_complete complete.address_complete &&;

    return complete;
  }

  handlePaymentInfos(user, params, skip) {
    var _this = this;

    user.company.paymentInfos = null;
    user.company.paymentInfos = user.company.undeletedPaymentInfos;
    _this.$localStorage.logged_user = user;
    //dashboardType: "es", action: "login"

    _this.$timeout(function () {
      $("body").removeClass();
      if (!skip) {
        _this.$state.go("jobsdashboard", {filter: "published"});
        //_this.pullCompanyUserInfo();
      }
    }, 100);
  }

  pullCompanyUserInfo() {
    this.validateUserByTokenWebTrimmed(this.getAccessToken())
      .then((response) => {
        this.setMostRecentUser(response.data);
        this.emitMostRecentUser();
        this.$rootScope.$emit("SetProfilePicture", response.data);
        //emit new user to the app?
      })
      .catch((error) => {
        this.logout();
      });
  }

  validateUserByTokenWebTrimmed(token) {
    token = token.trim();
    let req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + this.loginUrlWithValidate,
      headers: {Authorization: "Bearer " + token},
      data: {},
    };
    return this.$http(req);
  }

  changePlans(plan_id) {
    var _this = this;
    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/bulk-subscription?format=json",
      headers: {
        "Content-Type": undefined,
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {
        companiesAndPlans: [
          {
            company: _this.$localStorage.logged_user.company.id,
            plan: plan_id,
          },
        ],
      },
    };

    return _this.$http(req);
  }

  job_details_register(user) {
    var _this = this;
    let url = null;
    console.log("what is the user right before");
    console.dir(user);
    url = _this.$env.getAPIEndPoint() + "register/register?format=json&fields=id,username,email,firstName,lastName";
    var req = {
      method: "POST",
      url: url,
      data: {
        firstName: user.first_name,
        lastName: user.last_name,
        username: user.email,
        email: user.email,
        password: user.password,
        termsOfService: true,
        acceptedWebAgreement: true,
        homeContactInfo: {
          phoneMobile: user.phone,
        },
      },
    };

    return _this.$http(req);
  }

  job_details_login(user) {
    var _this = this;

    var req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + _this.signInUrlLazy,
      data: {
        username: user.email,
        password: user.password,
      },
    };

    return _this.$http(req);
  }

  fancyLoad(cls, lng) {
    var _this = this;

    _this.$timeout(function () {
      $(cls)
        .slice(0, lng)
        .each(function (i, row) {
          setTimeout(function () {
            $(row).fadeIn(1000);
          }, 100 * i);
        });
    });
  }

  getCompanyPayInfo() {
    var _this = this;

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + _this.validatePayInfo,
      headers: {
        Authorization: "Bearer " + _this.getAccessToken(),
      },
      data: {},
    };

    return _this.$http(req);
  }
}

AuthService.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "security",
  "$q",
  "env",
  "$rootScope",
  "$timeout",
  "$location",
  "$cookies",
];



// WEBPACK FOOTER //
// ./client/app/services/auth.js